import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Header from '../../Shared/Header/Header';
import Services from './Services';

function AllServices() {
    return (
        <div>
            <Header />
            <Services />
            <Footer />
        </div>
    );
}

export default AllServices;
